import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { BUSINESS } from "../config/business";

// Simple TikTok glyph since lucide ships a slightly different style
function TikTokIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden {...props}>
      <path d="M19.321 6.733a5.78 5.78 0 0 1-3.77-1.39 5.78 5.78 0 0 1-1.97-3.343h-3.297v12.63a2.69 2.69 0 1 1-2.69-2.69c.153 0 .302.013.447.038v-3.356a6.047 6.047 0 1 0 5.54 6.008V9.24a9.027 9.027 0 0 0 5.74 2.04V7.938a5.812 5.812 0 0 1 0-1.205z" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer
      className="mt-24 bg-[#0D0D0E] text-[#E8E6DF]"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="mb-5">
            {/* Logo is now the primary wordmark — dark bg suits the original logo */}
            <img
              src={BUSINESS.logoUrl}
              alt="Woodstone Construction"
              className="h-16 md:h-20 w-auto object-contain"
            />
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#C9A876] mt-3">
              {BUSINESS.location}
            </div>
          </div>
          <p className="text-[#BDBDB4] max-w-md leading-relaxed text-[15px]">
            Melbourne-based decking, pergola, and landscaping specialists.
            Composite and Merbau decks, pergolas, artificial turf, garden beds
            and complete outdoor makeovers — built to last.
          </p>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-[0.2em]">
            Explore
          </h3>
          <ul className="space-y-2 text-[15px]">
            <li>
              <Link
                to="/decking-cost-calculator-melbourne"
                className="hover:text-white transition-colors"
                data-testid="footer-link-calculator"
              >
                Deck cost calculator
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-white transition-colors"
                data-testid="footer-link-services"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-white transition-colors"
                data-testid="footer-link-contact"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-[0.2em]">
            Reach us
          </h3>
          <ul className="space-y-3 text-[15px]">
            <li className="flex items-start gap-2">
              <Phone size={16} className="mt-1 text-[#C9A876]" />
              <a
                href={`tel:${BUSINESS.phone}`}
                className="hover:text-white"
                data-testid="footer-phone"
              >
                {BUSINESS.phoneDisplay}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={16} className="mt-1 text-[#C9A876]" />
              <a
                href={`mailto:${BUSINESS.email}`}
                className="hover:text-white break-all"
                data-testid="footer-email"
              >
                {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-1 text-[#C9A876]" />
              <span>{BUSINESS.serviceArea}</span>
            </li>
            <li className="flex items-center gap-4 pt-2">
              <a
                href={BUSINESS.socials.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="hover:text-white"
                data-testid="footer-instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href={BUSINESS.socials.tiktok}
                target="_blank"
                rel="noreferrer"
                aria-label="TikTok"
                className="hover:text-white"
                data-testid="footer-tiktok"
              >
                <TikTokIcon width={18} height={18} />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#22382D]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[13px] text-[#8F8F86]">
          <div>
            © {new Date().getFullYear()} Woodstone Construction. All rights
            reserved.
          </div>
          <div className="flex items-center gap-4">
            <Link
              to="/privacy"
              className="hover:text-white transition-colors"
              data-testid="footer-link-privacy"
            >
              Privacy policy
            </Link>
            <span className="text-[#3F4F46]">·</span>
            <span>Crafted in Melbourne, VIC.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
